<template>
  <div @click="hide">
    <div class="mask fixed l0 t0 r0 b0 rgba5" v-if="showTag">
    </div>
    <div class="main" v-if="showTag">
      <img class="fixed l0" :src="url" alt="" :style="style" @transitionend="transitionend">
    </div>
  </div>
</template>

<script>
import {readImg} from "../lib/util";

/**
 * 图片放大旋转组件
 * methods
 * **** show(url)
 */
export default {
  name: 'v-bar-scan',
  data() {
    return {
      url: '',
      style: {},
      showTag: false
    }
  },
  methods: {
    async show(url) {
      this.status = 'show'
      this.showTag = true
      this.url = url
      const img = await readImg(url)
      let mh = img.height
      let mw = img.width

      let wh = Math.min(window.innerHeight, screen.availHeight)
      let ww = Math.min(window.innerWidth, screen.availWidth)

      let mw2 = ww
      let mh2 = (ww / mw) * mh

      let hScale = wh / mw2
      let wScale = ww / mh2

      let scale = Math.min(hScale, wScale) * 0.8
      this.style = {
        marginTop: `-${mh}px`,
        transform: `rotate(90deg) scale(${scale},${scale})`
      }
    },
    hide() {
      this.status = 'hide'
      this.$set(this.style, 'transform', '')
    },
    transitionend() {
      if (this.status == 'hide') {
        this.style = {}
        this.showTag = false
      }
    }
  }
}
</script>

<style scoped>
img {
  width: 100%;
  top: 50%;
  transition: all 0.5s;
  z-index: 12000;
}

.mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}

.main {
  z-index: 11000;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/plugins/v-bar-scan.vue